import React, { useState } from 'react';

import { useGetTransactionsQuery } from 'features/transactions';
import { GetTransactionsParams } from 'features/transactions/store/types';

import { TransactionsFilter, TransactionsTable } from 'widgets/transactions';

const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

type FilterValues = GetTransactionsParams

function Transactions() {
  const [params, setParams] = useState<GetTransactionsParams>(initParams);

  const {
    transactionsList,
    isTransactionsFetching
  } = useGetTransactionsQuery(params, {
    selectFromResult: ({ data, isFetching }) => ({
      transactionsList: data?.items ?? [],
      isTransactionsFetching: isFetching,
    })
  });

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };


  const handleFilterSubmit = (formData: FilterValues) => {
    setParams((prev) => ({
      ...formData,
      page: 1,
      pageSize: prev.pageSize
    }));
  };

  const handleFilterReset = () => {
    setParams((prev) => ({
      ...initParams,
      pageSize: prev.pageSize,
    }));
  };

  const handleUserIdClick = (userId: number | string) => {
    setParams((prev) => ({
      ...prev,
      userId: Number(userId)
    }));
  };

  return (
    <>
      <TransactionsFilter
        onSubmit={handleFilterSubmit}
        onReset={handleFilterReset}
      />
      <TransactionsTable
        items={transactionsList}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        isLoading={isTransactionsFetching}
        onPageChange={handlePaginationChange}
        onUserIdClick={handleUserIdClick}
      />
    </>
  );
}

export default Transactions;
